//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//

/* eslint-disable max-len */
export const decimalNumberingDigits: { [x: string]: string[] } = {
  adlm: ['\u{1e950}'],
  ahom: ['\u{11730}'],
  arab: ['٠'],
  arabext: ['۰'],
  bali: ['᭐'],
  beng: ['০'],
  bhks: ['\u{11c50}'],
  brah: ['\u{11066}'],
  cakm: ['\u{11136}'],
  cham: ['꩐'],
  deva: ['०'],
  diak: ['\u{11950}'],
  fullwide: ['０'],
  gara: ['\u{10d40}'],
  gong: ['\u{11da0}'],
  gonm: ['\u{11d50}'],
  gujr: ['૦'],
  gukh: ['\u{16130}'],
  guru: ['੦'],
  hanidec: ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
  hmng: ['\u{16b50}'],
  hmnp: ['\u{1e140}'],
  java: ['꧐'],
  kali: ['꤀'],
  kawi: ['\u{11f50}'],
  khmr: ['០'],
  knda: ['೦'],
  krai: ['\u{16d70}'],
  lana: ['᪀'],
  lanatham: ['᪐'],
  laoo: ['໐'],
  latn: ['0'],
  lepc: ['᱀'],
  limb: ['᥆'],
  mathbold: ['\u{1d7ce}'],
  mathdbl: ['\u{1d7d8}'],
  mathmono: ['\u{1d7f6}'],
  mathsanb: ['\u{1d7ec}'],
  mathsans: ['\u{1d7e2}'],
  mlym: ['൦'],
  modi: ['\u{11650}'],
  mong: ['᠐'],
  mroo: ['\u{16a60}'],
  mtei: ['꯰'],
  mymr: ['၀'],
  mymrepka: ['\u{116da}'],
  mymrpao: ['\u{116d0}'],
  mymrshan: ['႐'],
  mymrtlng: ['꧰'],
  nagm: ['\u{1e4f0}'],
  newa: ['\u{11450}'],
  nkoo: ['߀'],
  olck: ['᱐'],
  onao: ['\u{1e5f1}'],
  orya: ['୦'],
  osma: ['\u{104a0}'],
  outlined: ['\u{1ccf0}'],
  rohg: ['\u{10d30}'],
  saur: ['꣐'],
  segment: ['\u{1fbf0}'],
  shrd: ['\u{111d0}'],
  sind: ['\u{112f0}'],
  sinh: ['෦'],
  sora: ['\u{110f0}'],
  sund: ['᮰'],
  sunu: ['\u{11bf0}'],
  takr: ['\u{116c0}'],
  talu: ['᧐'],
  tamldec: ['௦'],
  telu: ['౦'],
  thai: ['๐'],
  tibt: ['༠'],
  tirh: ['\u{114d0}'],
  tnsa: ['\u{16ac0}'],
  tols: ['\u{11de0}'],
  vaii: ['꘠'],
  wara: ['\u{118e0}'],
  wcho: ['\u{1e2f0}'],
};
